l = require 'app/scripts/lib/localize'
PopOver = require 'app/scripts/views/lib/pop-over'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('file_link_handler')
Util = require 'app/scripts/lib/util'
_ = require 'underscore'

FileLinkComponent = class extends React.Component
  displayName: 'FileLinkComponent'

  render: ->
    { url } = @props

    t.render ->
      t.div ->
        t.p ->
          t.format 'browsers-prevent-file-links'
        t.input '.js-autofocus',
          type: 'text'
          value: url
          readOnly: true
          onFocus: (e) ->
            _.defer -> e.target.select()

module.exports = (linkElem) ->
  PopOver.show
    elem: linkElem
    getViewTitle: ->
      l(['view title', 'open file link'])
    reactElement: React.createElement FileLinkComponent,
      key: 'FileLinkComponent'
      url: linkElem.href
